import { render } from "./FooterLink.vue?vue&type=template&id=8da8b140&scoped=true"
import script from "./FooterLink.vue?vue&type=script&lang=js"
export * from "./FooterLink.vue?vue&type=script&lang=js"

import "./FooterLink.vue?vue&type=style&index=0&id=8da8b140&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-8da8b140"

export default script